module.exports = __webpack_public_path__ + "static/media/anon-avatar.a4b74a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anon-avatar.png
// module id = 804
// module chunks = 2